export default __webpack_public_path__ + "static/media/B0007.40b9f7f4.png";